import { render, staticRenderFns } from "./SalesLeadsChart.vue?vue&type=template&id=436455e0&scoped=true&"
import script from "./SalesLeadsChart.vue?vue&type=script&lang=js&"
export * from "./SalesLeadsChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "436455e0",
  null
  
)

export default component.exports